import {
  NotificationService,
  NotificationsComponent,
  OuiBoxComponent,
  OuiFooterComponent,
  OuiRowComponent,
  OuiStackComponent,
} from '@aiz-gl/omni-ui';
import { Component, computed, effect, inject } from '@angular/core';
import { Router, RouterOutlet } from '@angular/router';
import { LogoComponent } from './components/logo/logo.component';
import { NavigationMenuComponent } from './components/navigation-menu/navigation-menu.component';
import { UserMenuComponent } from './components/user-menu/user-menu.component';
import { AuthService } from './services/auth/auth.service';
import { NavigationService } from './services/navigation/navigation.service';

// The Alert component never auto-dismisses on its own and Snackbar defaults to a 35s timeout, so both feel "stuck".
const AUTO_DISMISS_MS = 8000;

@Component({
  selector: 'app-root',
  imports: [
    OuiStackComponent,
    OuiRowComponent,
    NavigationMenuComponent,
    RouterOutlet,
    LogoComponent,
    NotificationsComponent,
    UserMenuComponent,
    OuiFooterComponent,
    OuiBoxComponent,
  ],
  templateUrl: './app.component.html',
  styleUrls: ['./app.component.css'],
  standalone: true,
})
export class AppComponent {
  nav = inject(NavigationService);
  auth = inject(AuthService);
  router = inject(Router);
  private readonly notifications = inject(NotificationService);

  constructor() {
    effect((onCleanup) => {
      if (!this.notifications.alert()) return;
      const timer = setTimeout(
        () => this.notifications.hideAlert(),
        AUTO_DISMISS_MS,
      );
      onCleanup(() => clearTimeout(timer));
    });

    effect((onCleanup) => {
      if (!this.notifications.snackbar()) return;
      const timer = setTimeout(
        () => this.notifications.hideSnackbar(),
        AUTO_DISMISS_MS,
      );
      onCleanup(() => clearTimeout(timer));
    });
  }

  readonly showSignInExperience = computed(() => {
    this.nav.navigationEnd();
    return !this.auth.isAuthenticated() && !this.router.url.startsWith('/login/callback');
  });

  readonly showApplicationChrome = computed(() => {
    this.nav.navigationEnd();
    return !this.nav.routeData()?.['hideApplicationChrome'];
  });

  async signIn() {
    await this.auth.signIn();
  }
}
